export default "__VITE_ASSET__DYkxkiLe__"